<template>
    <webinar-template
        v-if="hasProShows"
        :config="config"
    />
</template>

<script>
import WebinarTemplate from './WebinarTemplate';
import '../../../../../../images/pat.png';

export default {
    components: {
        WebinarTemplate,
    },

    props: {
        hasProShows: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        config: {
            title: 'Podcasting 101',
            date: false,
            duration: '32 mins',
            subtitle: 'How to Start a Podcast in 2022 ',
            avatar: {
                src: '/images/pat.png',
                alt: 'Pat Flynn',
            },
            hosts: '<strong>Pat Flynn</strong>',
            description: ' \n' +
                ' Want to learn how to start a podcast in 2022 fast and without overspending? I\'ve published two of the most viewed podcasting tutorials on YouTube with millions of views, and I\'m back with an updated version with everything you need in just one video.',
            cta: {
                url: ' https://www.youtube.com/watch?v=Q8pfZna6H6Q&list=PLzJ1r4EGn-eksdBA9rzmviJlzpaOF3TBp&index=1',
                text: 'Watch Video',
            },
        },
    }),
};
</script>
